import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';

import MoreVertIcon from '@mui/icons-material/MoreVert';

import withConfirmAction from '@ts-core/components/HOC/withConfirmAction';

const SubjectSecondaryActionMenu = (props) => {
  const { open, subject, onClose, onOpen, onAddSubject, onEditSubject, onRemoveSubject, onToggleSubject, handleConfirmAction } = props;

  const isMenuEnabled = !!onAddSubject || !!onEditSubject || !!onRemoveSubject;
  const menuButtonRef = useRef();

  const handleAddSubSubject = useCallback(() => {
    onAddSubject(subject);
  }, [onAddSubject, subject]);

  const handleEdit = useCallback(() => {
    onEditSubject(subject);
    onClose();
  }, [onClose, onEditSubject, subject]);

  const handleRemove = useCallback(() => {
    onClose();
    handleConfirmAction(onRemoveSubject, subject, {
      id: 'dialog.confirmRemoveItem.title',
      values: { item: subject.name },
    });
  }, [onClose, handleConfirmAction, onRemoveSubject, subject]);

  const handleToggleSubject = useCallback(() => {
    onToggleSubject(subject);
  }, [onToggleSubject, subject]);

  return (
    <>
      {onToggleSubject && <Switch color="secondary" checked={subject.enabled} onChange={handleToggleSubject} />}
      {isMenuEnabled && (
        <IconButton onClick={onOpen(subject)} ref={menuButtonRef} size="large">
          <MoreVertIcon />
        </IconButton>
      )}
      {isMenuEnabled && (
        <Menu id="subject-menu" anchorEl={menuButtonRef.current} open={open} onClose={onClose}>
          {onEditSubject && (
            <MenuItem onClick={handleEdit}>
              <FormattedMessage id="button.edit.label" />
            </MenuItem>
          )}
          {onRemoveSubject && (
            <MenuItem onClick={handleRemove}>
              <FormattedMessage id="button.remove.label" />
            </MenuItem>
          )}
          {onAddSubject && (
            <MenuItem onClick={handleAddSubSubject}>
              <FormattedMessage id="button.addSubSubject.label" />
            </MenuItem>
          )}
        </Menu>
      )}
    </>
  );
};

SubjectSecondaryActionMenu.propTypes = {
  open: PropTypes.bool,
  subject: PropTypes.object,

  onClose: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  onAddSubject: PropTypes.func,
  onEditSubject: PropTypes.func,
  onRemoveSubject: PropTypes.func,
  onToggleSubject: PropTypes.func,

  handleConfirmAction: PropTypes.func.isRequired,
};

SubjectSecondaryActionMenu.defaultProps = {
  open: false,
  subject: undefined,

  onAddSubject: undefined,
  onEditSubject: undefined,
  onRemoveSubject: undefined,
  onToggleSubject: undefined,
};

export default withConfirmAction(SubjectSecondaryActionMenu);
